import { render } from "./EntitlementNoMatchModal.vue?vue&type=template&id=1676e04a&scoped=true"
import script from "./EntitlementNoMatchModal.vue?vue&type=script&lang=js"
export * from "./EntitlementNoMatchModal.vue?vue&type=script&lang=js"

import "./EntitlementNoMatchModal.vue?vue&type=style&index=0&id=1676e04a&scoped=true&lang=css"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1676e04a"]])

export default __exports__